const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export type QualificationChilipiperLead = {
  FirstName: string
  LastName: string
  Email: string | undefined
  coreLeadId?: string
}

export function buildChilipiperLead({
  firstName,
  lastName,
  email,
  leadId,
}: {
  firstName: string
  lastName: string
  email: string | undefined
  leadId: string | null | undefined
}): QualificationChilipiperLead {
  return {
    FirstName: firstName,
    LastName: lastName,
    Email: email,
    ...(leadId && UUID_PATTERN.test(leadId) && { coreLeadId: leadId }),
  }
}
